import React from "react";

import { Button } from "@material-ui/core";
import clsx from "clsx";

import * as colors from "../../theme/colors";
import ArrowWave from "../arrow-wave/arrow-wave";
import {
  getStyles,
  isDisabledMode,
  styleTypes,
  useStyles,
} from "./text-button.styles";

const TextButton = ({
  mode = "primary",
  endIcon,
  isArrowWave,
  className,
  disabled,
  onClick,
  label,
  startIcon,
  isActive,
  ...props
}) => {
  const classes = useStyles(getStyles(disabled, isActive, mode));
  const [active, setActive] = React.useState(false);

  const ariaDisabled = !disabled && isDisabledMode(mode) ? true : undefined;

  return (
    <Button
      aria-label={label}
      disabled={disabled}
      aria-disabled={ariaDisabled}
      {...props}
      startIcon={startIcon}
      onClick={ariaDisabled ? undefined : onClick}
      disableTouchRipple={true}
      onMouseOver={() => setActive(true)}
      onMouseOut={() => setActive(false)}
      endIcon={isArrowWave ? <ArrowWave isActive={active} fill={disabled ? styleTypes.disabled.mainColor : colors.darkThemeGreen}/> : endIcon}
      className={className ? clsx(classes.btnContainer, className) : classes.btnContainer}
    >
      {<span aria-hidden="true">{label}</span>} {props.children}
    </Button>
  );
};

export default TextButton;
